/** @jsx jsx */

import { jsx } from '@emotion/core';

import { Colors, Grid, Icon, Text } from '@zapier/design-system';

import Dismiss from 'app/developer-v3/components/Dismiss';
import Number from 'app/developer-v3/components/Number';
import Link from 'app/common/components/Link';

import Styles from '../CTAVersioning.styles';

type Props = {
  completedZapsCount: number;
  helpLinks: React.ReactNode;
  onDismiss: () => void;
};

function MigrationDone(props: Props) {
  const { completedZapsCount, helpLinks, onDismiss } = props;

  return (
    <div css={Styles.root(Colors.StatusSuccessWeakest)}>
      <Grid columns="30px auto 20px" gap={20}>
        <Icon color="StatusSuccess" name="formCheckCircle" size={30} />
        <div>
          <Text fontWeight={600} tag="h2" type="Body4">
            Update complete
          </Text>
          <Text margin="10px 0px 0px" tag="p">
            We updated <Number isFriendly={true}>{completedZapsCount}</Number>{' '}
            Zaps. {helpLinks} If you notice any issues, contact us at{' '}
            <Link href="mailto:partners@zapier.com">partners@zapier.com</Link>.
          </Text>
        </div>
        <Dismiss onDismiss={onDismiss} />
      </Grid>
    </div>
  );
}

export default MigrationDone;
